function countOccurrences(s, ch) {
  var counter = 0;
  for (var i = 0; i < s.length; i++) {
    if (s.charAt(i) === ch) {
      counter++;
    }
  }
  return counter;
}
export var dateHandler = editable => {
  var DATE_DELIMITER = '/';
  var DATE_DELIMITER_BLOCK_SIZE = 3;
  if (editable.length < 1) return {
    editable,
    dateHint: ''
  };
  if (editable === '/') {
    editable = editable.slice(0, -1);
  }
  if (editable.length === 1) {
    if (editable[0] > '1') {
      editable = '0' + editable;
    }
  }
  if (editable.length === 2) {
    if (editable === '00') {
      editable = editable.slice(0, -1);
    } else if (editable[0] > '0' && editable[1] > '2') {
      editable = '12';
    } else if (editable[0] > '1') {
      editable = editable.slice(0, -1);
    }
  }
  if (editable.length > 2) {
    if (editable[0] === '0' && editable[1] === '0') {
      editable = editable.slice(0, 2);
    } else if (editable[0] > '0' && editable[1] > '2') {
      editable = editable.slice(0, 2);
    } else if (editable[0] > '1') {
      editable = editable.slice(0, -1);
    }
  }
  if (editable.length !== 0 && editable.length % DATE_DELIMITER_BLOCK_SIZE === 0) {
    var c = editable.charAt(editable.length - 1);
    if (c === DATE_DELIMITER) editable = editable.slice(0, editable.length - 1);
  }
  if (editable.length !== 0 && editable.length % DATE_DELIMITER_BLOCK_SIZE === 0 && countOccurrences(editable.toString(), '/') === 0) {
    editable = editable.slice(0, editable.length - 1) + DATE_DELIMITER + editable.slice(editable.length - 1);
  }
  var dateHint = dateValidator(editable);
  return {
    editable,
    dateHint: dateHint === undefined ? '' : dateHint
  };
};
export var expiryChecker = (month, year) => {
  var currentDate = new Date();
  var currentYear = currentDate.getFullYear() % 100;
  var currentMonth = currentDate.getMonth() + 1;
  if (year < currentYear) {
    return true;
  } else if (year === currentYear) {
    return month < currentMonth;
  }
};
export var dateValidator = inputDate => {
  if (inputDate.length != 5) {
    return '';
  }
  var _inputDate$split = inputDate.split('/'),
    monthStr = _inputDate$split[0],
    yearStr = _inputDate$split[1];
  var month = parseInt(monthStr, 10);
  var year = parseInt(yearStr, 10);
  var isMonthValid = !isNaN(month) && month >= 1 && month <= 12;
  var isYearValid = !isNaN(year) && year >= 0 && year <= 99;
  if (isMonthValid && isYearValid) {
    if (expiryChecker(month, year)) {
      return 'your card is expired';
    }
  } else {
    return 'invalid expiry date';
  }
};